import React, { useRef, useState, useEffect } from "react";
import { Modal, Dropdown } from "react-bootstrap";
import { getPostal } from "../../actions/autocompleteActions";
import PropTypes from "prop-types";
import "../../assets/css/icon.css";
import "../../assets/css/bundle.css";
import "../../assets/css/component.css";
import { useSelector, useDispatch } from "react-redux";
import { upperCaseAddress } from "./addressFunctions";
import axios from "axios";
import { useForm } from "react-hook-form";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import "./DeliveryModal.css";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

const formatAddress = (string) => {
  const arr = string.split(" ")
  let newArr = arr.map((item) => {
    return (item[0] + item.toLowerCase().substring(1, item.length))
  })
  return newArr.join(" ")
}


const DeliveryModal = (props) => {
  const { register, handleSubmit } = useForm();
  const hideModal = () => {
    props.closeModal()
  }
  const [location, setLocationDetails] = useState({
    latitude: "",
    longtitude: ""
  })
  const [timer, setTimer] = useState(null)

  const [visibility, setVisible] = useState("none")
  const [postal, setPostal] = useState("")
  const [addressForm, setFormVisible] = useState("hidden")
  const [buildingName, setBuildingName] = useState("")
  const [unitNumber, setUnitNumber] = useState("")
  const [fullAddress, setFullAddress] = useState("")
  const [floorNumber, setFloorNumber] = useState("")
  const [contactName, setcontactName] = useState("")
  const [contactNumber, setcontactNumber] = useState("")
  const [contactError, setContactError] = useState("");
  const [floorError, setFloorError] = useState("");
  const [unitError, setunitError] = useState("");
  const [postalError, setPostalError] = useState("");
  const [note, setNote] = useState("")
  const [showCashRegisterbanner, setShowCashRegisterbanner] = useState(false)
  const [ShowCashRegisterbannermessage, setShowCashRegisterbannermessage] = useState(false)

  //STATES FROM THE REDUX STORE
  const postalCodes = useSelector((state) => (state.postal.postalCodes.results))
  const loading = useSelector((state) => (state.postal.loading))
  const dispatch = useDispatch()
  //--------------------------

  //ERROR MESSAGE TO RENDER
  const [errorMessage, setErrorMessage] = useState("")
  //----------------------

  //REFERENCES FOR THE VARIOUS INPUT ELEMENTS
  const postalCodeElement = useRef(null)
  const buildingNameElement = useRef(null)
  const unitNumberElement = useRef(null)
  const dropdownRef = useRef(null)
  const contactNameElement = useRef(null)
  const contactNumberElement = useRef(null)
  const floorErrorElement = useRef(null)
  //------------------------------------

  const handleClick = (event) => {
    if (dropdownRef.current) {
      if (dropdownRef.current.contains(event.target)) {
        return
      }

      setVisible("none")
    }
  }

  //EVENT FOR DETECTING CLICK OUTSIDE
  useEffect(() => {
    document.addEventListener("mousedown", handleClick)

    return () => {
      document.removeEventListener("mousedown", handleClick)
    }
  }, [])

  //DETECT CHANGES FOR POSTAL CODE, THEN SEND REQUEST
  useEffect(() => {
    if (postal !== "") {
      dispatch(getPostal(postal))
    }

  }, [postal])

  useEffect(() => { //HIDE INPUT ELEMENTS IF FULL ADDRESS IS BLANK
    if (buildingName === "") {
      setFormVisible("hidden")
    }
  }, [buildingName])

  const myRef = useRef();
  const onSubmit = async (data) => {

    if (postal === "") {
      setPostalError("Postal code is required");
      return;
    }

    if (unitNumberElement.current.value.trim() === "") {
      setunitError("Unit number is required");
      return;
    }

    if (floorNumber.trim() === "") {
      if (floorError === "")
        setFloorError("Floor number is required");
      return;
    }
    if (localStorage.getItem('location_id') != null) {
      const locationId = localStorage.getItem("location_id");
      if (locationId) {
        try {
          let data = {
            location_id: locationId
          }
          const result = await axios.post("/rapyd/checkcashregister", data);
          if (result.data.status === 'closed') {
            setShowCashRegisterbanner(true)
            setShowCashRegisterbannermessage(result.data.message)
            return
          } else {
            setShowCashRegisterbanner(false)
            setShowCashRegisterbannermessage("")
          }
          if (result.data.status === 'open') {
            setShowCashRegisterbanner(false)
            setShowCashRegisterbannermessage("")
          }
        } catch (err) {
          console.error("Error:", err);
        }
      };
    }
    //ADDRESS FORMATTING(SET TO LOWER CASE EXCEPT FIRST LETTER AND COMBINE POSTAL CODE INTO ONE ADDRESS)
    let deliveryAddress = [
      buildingNameElement?.current?.value, // building name
      unitNumberElement?.current?.value ? unitNumberElement?.current?.value : "", // unit
      postal ? "Singapore " + postal : "" // postal
    ].filter(Boolean).join(" ");

    if (floorNumber?.trim()) {
      deliveryAddress += `\nFloor: ${floorNumber}`;
    }

    if (contactName?.trim() || contactNumber?.trim()) {
      deliveryAddress += `\nContact: ${contactName || ""}${contactNumber ? " (" + contactNumber + ")" : ""}`;
    }

    let formData = { //DATA TO PASS TO ANOTHER COMPONENT, RIGHT-SIDEBAR.JS
      ...location,
      full_address: deliveryAddress,
      note: note
    }

    //SET ADDRESS INFORMATION IN THE LOCAL STORAGE
    localStorage.setItem("d_address", formData.full_address)
    localStorage.setItem("latitude", formData.latitude)
    localStorage.setItem("longtitude", formData.longtitude)
    localStorage.setItem("additional_note", formData.note)

    //FUNCTION PROPERTY FROM RIGHTSIDEBAR JS, SET THE STATE TO THE FORM DATA AS FROM BEFORE
    props.setAddress(formData);

    //MODAL VISIBILITY
    props.closeModal();
    props.showOutlet();
  };
  const handleContactChange = (e) => {
    const value = e.target.value;
    if (value && !/^\+?\d+$/.test(value)) {
      setContactError("Enter a valid phone number (numbers only)");
      return
    } else {
      setContactError("");
    }
    setcontactNumber(value);
  };
  const returnAddress = (data) => {

    if (!data) {
      return ""
    }

    let array = []

    let maxLength = (data.length < 5) ? data.length : 5

    for (let i = 0; i < maxLength; ++i) {
      const roadName = data[i].ROAD_NAME[0] + data[i].ROAD_NAME.toLowerCase().substring(1, data[i].ROAD_NAME.length)
      const fullAddress = upperCaseAddress(data[i].ADDRESS)

      //POPULATE DROPDOWN LIST
      array.push(
        <div key={i} onClick={(event) => { //ONCLICK EVENT TO SET THE VARIOUS INPUT ELEMENTS AND THE STATES TO THE CURRENT
          //ADDRESS THAT THE USER HAS CLICKED

          setLocationDetails({
            ...location,
            latitude: data[i].LATITUDE,
            longtitude: data[i].LONGITUDE
          })
          setPostal(data[i].POSTAL === "NIL" ? "" : data[i].POSTAL); //DATA MAY PASS NIL, LEAVE INPUT ELEMENT BLANK IF SO
          setVisible("none")
          setFormVisible("visible")
          setBuildingName(upperCaseAddress(data[i].ADDRESS).replace("Singapore " + data[i].POSTAL, "").trim())
          setFullAddress(data[i].ADDRESS)
        }} style={{ whiteSpace: "unset", width: "100%", fontSize: "75%", textAlign: "center" }} className="dropdown-item">

          {
            fullAddress
          }
        </div>
      )

    }
    return array
  }


  return (
    <Modal show={props.show} onHide={hideModal} dialogClassName="delivery premium-modal" centered>
      <Modal.Header>
        <Modal.Title>Your delivery address</Modal.Title>
        <ModalCloseButton
          onClick={hideModal}
          style={{ position: 'static', width: '32px', height: '32px' }}
        />
      </Modal.Header>
      <Modal.Body className="">
        {
          showCashRegisterbanner &&
          (<div className="cash-register-banner">🚫 {ShowCashRegisterbannermessage}</div>)
        }
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label className="control-label">Postal Code</label>
            <div className="search-box">
              <i className="search-icon"></i>
              <Dropdown>
                <input value={postal} autoComplete="off" ref={postalCodeElement} onChange={(event) => {
                  event.target.value = event.target.value.replace(/\D/g, "")
                  setPostal(postalCodeElement.current.value)
                  setVisible("show")
                  if (event.target.value.trim() !== "") setPostalError("");
                }}
                  id="inputField"
                  className="premium-input"
                  type="text"
                  placeholder="Enter your postal code"
                  onFocus={() => { console.log(visibility); setVisible("show") }}

                />
                <div ref={dropdownRef} className={`dropdown-menu premium-autocomplete-menu ${postal === "" ||
                  postalCodes?.length === 0 ? "none" : visibility} dropdown-menu-lg-end`}>
                  {loading === true ? <div style={{ textAlign: "center", padding: "10px" }}>Loading...</div> : returnAddress(postalCodes)}
                </div>
              </Dropdown>
              {postalError && <small className="text-danger mt-1 d-block">{postalError}</small>}
            </div>
          </div>
          <div className="row mb-3" style={{ visibility: addressForm }}>
            <div className="col-md-12">
              <div className="form-group mb-0">
                <input required className="premium-input" type="text" placeholder="Full address" value={buildingName}
                  ref={buildingNameElement} onChange={() => {
                    setFullAddress(fullAddress.replace(fullAddress, buildingNameElement.current.value + (
                      unitNumber === "" ? "" : " " + (postal === "" ? "" : " Singapore " + postal)
                    )))
                    setBuildingName(buildingNameElement.current.value)
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row mb-3" style={{ visibility: addressForm }}>
            <div className="col-md-6 mb-3 mb-md-0">
              <div className="form-group mb-0">
                <input className="premium-input" type="text" defaultValue={unitNumber} placeholder="Unit No."
                  ref={unitNumberElement} onChange={(e) => {
                    setUnitNumber(e.target.value)
                    if (e.target.value.trim() !== "") setunitError("");
                  }}
                />
                {unitError && <small className="text-danger mt-1 d-block">{unitError}</small>}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-0">
                <input className="premium-input" type="text" defaultValue={floorNumber} placeholder="Floor Number"
                  ref={floorErrorElement} onChange={(e) => {
                    setFloorNumber(e.target.value)
                    if (e.target.value.trim() !== "") setFloorError("");
                  }}
                />
                {floorError && <small className="text-danger mt-1 d-block">{floorError}</small>}
              </div>
            </div>
          </div>
          <div className="row mb-3" style={{ visibility: addressForm }}>
            <div className="col-md-6 mb-3 mb-md-0">
              <div className="form-group mb-0">
                <input className="premium-input" type="text" defaultValue={contactName} placeholder="Contact Name"
                  ref={contactNameElement} onChange={(e) => { setcontactName(e.target.value) }}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-0">
                <input className="premium-input" type="text" defaultValue={contactNumber} placeholder="Contact No."
                  ref={contactNumberElement} onChange={(e) => { handleContactChange(e) }}
                />
                {contactError && <small className="text-danger mt-1 d-block">{contactError}</small>}
              </div>
            </div>
          </div>
          <div style={{ visibility: addressForm }} className="form-group mb-4">
            <label className="control-label">Note</label>
            <textarea className="premium-input" placeholder="Any special instructions for delivery" defaultValue={note} onChange={(event) => { setNote(event.target.value) }}></textarea>
          </div>
          <div className="form-action mt-5" style={!props.auth?.isAuthenticated || buildingName === "" ? {
            pointerEvents: "none", opacity: 0.4
          } : { pointerEvents: "auto", opacity: 1.0 }} onClick={onSubmit}
            data-testid="delivery_modal_btn">
            <div className="btn lg primary d-block">
              {props.auth?.isAuthenticated ? "Select outlet" : "Please login to select outlet"}
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};
DeliveryModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  postal: state.postal,
});
export default withTranslation()(
  connect(mapStateToProps, {
  })(
    DeliveryModal
  )
);